import { render } from "./TermsAndConditions.vue?vue&type=template&id=a9d239e8&scoped=true"
const script = {}

import "./TermsAndConditions.vue?vue&type=style&index=0&id=a9d239e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9d239e8"]])

export default __exports__